import Button from '@mui/material/Button';
import Delete from '@mui/icons-material/Delete';
import React from 'react';
import {requestRemoveAppStateFromLocalStorage} from 'util/redux/ReduxStateUtil';
import Tooltip from '@mui/material/Tooltip';

export const DeleteLocalCacheButton = () => (
	<Tooltip title={'Es werden nur Einstellungen gelöscht, die auch leicht wiederhergestellt werden können (z.B. Position/Größe von Popups oder Datenfilter in bestimmten Applikationen).'}>
		<Button
			variant="outlined"
			color="primary"
			onClick={requestRemoveAppStateFromLocalStorage}
		>
			<Delete/>
			Lokale Datenbank leeren
		</Button>
	</Tooltip>
);